export const VERSION = '2.37.2';
